import * as React from "react";
const SvgMyTasksIconConv = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.888 10.898a2.876 2.876 0 0 0 2.472-2.841 2.875 2.875 0 0 0-2.406-2.836M19.729 14.25c1.35.202 2.294.675 2.294 1.65 0 .671-.445 1.107-1.163 1.381"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.887 14.664c-3.214 0-5.96.487-5.96 2.432s2.729 2.445 5.96 2.445c3.214 0 5.958-.482 5.958-2.428s-2.727-2.449-5.958-2.449M11.887 11.888a3.819 3.819 0 1 0-3.82-3.819 3.804 3.804 0 0 0 3.792 3.819z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M5.885 10.898a2.875 2.875 0 0 1-2.472-2.841A2.875 2.875 0 0 1 5.819 5.22M4.044 14.25c-1.351.202-2.294.675-2.294 1.65 0 .671.444 1.107 1.162 1.381"
    />
  </svg>
);
export default SvgMyTasksIconConv;
